import type { RouteObject } from 'react-router';

import { AuthLayout } from '@/features/auth/auth-layout';

import { InvitePage } from './invite-page';

/**
 * The invite link, in the auth screens' shell but behind no guard: it works
 * signed out (to sign up or in, then come back) and signed in - including
 * for a brand-new invitee who hasn't onboarded, and never will once they
 * accept.
 */
export const inviteRoute: RouteObject = {
  element: <AuthLayout />,
  children: [{ path: 'invite', element: <InvitePage /> }],
};
